import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { toCssValue } from '../../../../../../../core/utils/theme.utils';
import { OwnershipNodesColorEnum } from '../../OwnershipConnectionsChart/OwnershipConnectionsChart.type';

interface Props {}

const ConnectionsLegend: React.FC<Props> = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.legendContainer}>
      <Box className={classes.legendBox}>
        <Box className={`${classes.divider} ${classes.current}`} />
        <Typography>{t('connections:ownershipLegend:current')}</Typography>
      </Box>
      <Box className={classes.legendBox}>
        <Box className={`${classes.divider} ${classes.historical}`} />
        <Typography>{t('connections:ownershipLegend:historical')}</Typography>
      </Box>
      <Box className={classes.legendBox}>
        <Box className={classes.swatchBox}>
          <Box className={`${classes.swatch} ${classes.expand}`} />
        </Box>
        <Typography>{t('connections:ownershipLegend:expand')}</Typography>
      </Box>
      <Box className={classes.legendBox}>
        <Box className={classes.swatchBox}>
          <Box className={`${classes.swatch} ${classes.others}`} />
        </Box>
        <Typography>{t('connections:ownershipLegend:others')}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    marginLeft: -theme.spacing(2),
  },
  legendBox: {
    display: 'flex',
    alignItems: 'center',
    padding: toCssValue([theme.spacing(1), theme.spacing(0)]),
    '& p': {
      fontSize: '13px',
      marginLeft: theme.spacing(4),
    },
  },
  divider: {
    width: '45px',
  },
  current: {
    height: '1px',
    background: `repeating-linear-gradient(to right,${theme.palette.secondary.light} 0,${theme.palette.secondary.light} 8px)`,
  },
  historical: {
    height: '1px',
    background: `repeating-linear-gradient(to right,${theme.palette.secondary.light} 0,${theme.palette.secondary.light} 8px,transparent 8px,transparent 12px)`,
  },
  // same width as the line swatches above, so every label stays aligned
  swatchBox: {
    width: '45px',
    display: 'flex',
    alignItems: 'center',
  },
  swatch: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
  },
  expand: {
    background: OwnershipNodesColorEnum.EXPAND,
  },
  others: {
    background: OwnershipNodesColorEnum.OTHERS,
  },
}));

export default ConnectionsLegend;
